export enum SubmissionScopeType {
  WorkspaceItem = 'WORKSPACE',
  WorkflowItem = 'WORKFLOW',
}
